import { useForm, useSelect } from '@refinedev/antd';
import { Edit } from '@refinedev/antd';
import { Form, Input, Checkbox, Card, Row, Col, Divider, Switch } from 'antd';
import { LabelWithHelp, SectionTitle } from '../../components/ui/HelpTooltip';

const permissionGroups = [
  {
    title: 'Foydalanuvchilar',
    key: 'users',
    permissions: ['read', 'update', 'block'],
    help: "Foydalanuvchilar ro'yxati va ularni boshqarish",
  },
  {
    title: 'Haydovchilar',
    key: 'drivers',
    permissions: ['read', 'update', 'verify', 'block'],
    help: "Haydovchilar ro'yxati, tasdiqlash va boshqarish",
  },
  {
    title: 'Hujjatlar',
    key: 'documents',
    permissions: ['read', 'review'],
    help: "Haydovchi hujjatlarini ko'rish va tasdiqlash",
  },
  {
    title: 'Sayohatlar',
    key: 'trips',
    permissions: ['read', 'update', 'cancel'],
    help: "Sayohatlarni ko'rish, tahrirlash va bekor qilish",
  },
  {
    title: "To'lovlar",
    key: 'payments',
    permissions: ['read'],
    help: "To'lovlar tarixini ko'rish",
  },
  {
    title: 'Murojatlar',
    key: 'support',
    permissions: ['read', 'reply', 'resolve'],
    help: "Foydalanuvchi murojatlarini ko'rish va javob berish",
  },
  {
    title: 'FAQ',
    key: 'faq',
    permissions: ['read', 'create', 'update', 'delete'],
    help: "Ko'p so'raladigan savollarni boshqarish",
  },
  {
    title: 'Promo kodlar',
    key: 'promo',
    permissions: ['read', 'create', 'update', 'delete'],
    help: "Chegirma kodlarini yaratish va boshqarish",
  },
  {
    title: 'Sozlamalar',
    key: 'settings',
    permissions: ['read', 'update'],
    help: "Tizim sozlamalarini o'zgartirish",
  },
  {
    title: 'Xodimlar',
    key: 'staff',
    permissions: ['read', 'create', 'update', 'delete'],
    help: "Admin xodimlarni yaratish va boshqarish",
  },
];

const permissionLabels: Record<string, string> = {
  read: "Ko'rish",
  create: 'Yaratish',
  update: 'Tahrirlash',
  delete: "O'chirish",
  block: 'Bloklash',
  verify: 'Tasdiqlash',
  review: "Ko'rib chiqish",
  reply: 'Javob berish',
  resolve: 'Hal qilish',
  cancel: 'Bekor qilish',
};

export const StaffEdit = () => {
  const { formProps, saveButtonProps, queryResult } = useForm({
    resource: 'admin/staff',
    redirect: 'show',
  });

  const staff = queryResult?.data?.data;

  return (
    <Edit saveButtonProps={saveButtonProps} title={`Xodimni tahrirlash: ${staff?.fullName || staff?.username || ''}`}>
      <Form {...formProps} layout="vertical">
        <Row gutter={24}>
          <Col xs={24} lg={12}>
            <Card
              title={
                <SectionTitle
                  title="Asosiy ma'lumotlar"
                  help="Xodimning shaxsiy ma'lumotlari"
                />
              }
            >
              <Form.Item
                label={
                  <LabelWithHelp
                    label="Login"
                    help="Xodim admin panelga kirish uchun foydalanadigan login"
                  />
                }
                name="username"
              >
                <Input disabled placeholder="Login o'zgartirib bo'lmaydi" />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label="Yangi parol"
                    help="Yangi parol o'rnatish uchun kiriting. Bo'sh qoldirsangiz parol o'zgarmaydi."
                  />
                }
                name="password"
                rules={[
                  { min: 6, message: "Kamida 6 ta belgi bo'lishi kerak" },
                ]}
              >
                <Input.Password placeholder="Yangi parol (ixtiyoriy)" />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label="To'liq ism"
                    help="Xodimning to'liq ismi va familiyasi"
                  />
                }
                name="fullName"
              >
                <Input placeholder="Abdullayev Abdulla" />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label="Telefon"
                    help="Xodimning telefon raqami"
                  />
                }
                name="phone"
              >
                <Input placeholder="+998901234567" />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label="Faol"
                    help="Xodimning tizimga kirish huquqi"
                  />
                }
                name="isActive"
                valuePropName="checked"
              >
                <Switch checkedChildren="Faol" unCheckedChildren="Nofaol" />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} lg={12}>
            <Card
              title={
                <SectionTitle
                  title="Ruxsatlar"
                  help="Xodimga qaysi bo'limlarga kirish va qanday amallar bajarishga ruxsat beriladi"
                />
              }
            >
              {permissionGroups.map((group) => (
                <div key={group.key} style={{ marginBottom: 16 }}>
                  <div style={{ fontWeight: 500, marginBottom: 8, display: 'flex', alignItems: 'center', gap: 4 }}>
                    <LabelWithHelp label={group.title} help={group.help} />
                  </div>
                  <Form.Item name={['permissions', group.key]} noStyle>
                    <Checkbox.Group>
                      {group.permissions.map((perm) => (
                        <Checkbox key={perm} value={perm}>
                          {permissionLabels[perm] || perm}
                        </Checkbox>
                      ))}
                    </Checkbox.Group>
                  </Form.Item>
                  <Divider style={{ margin: '12px 0' }} />
                </div>
              ))}
            </Card>
          </Col>
        </Row>
      </Form>
    </Edit>
  );
};
